module.exports = __webpack_public_path__ + "static/media/008 I GUERRA M_Scuole.f0b7477e.svg";